import { LinkProps } from '@/types/types'
import Link from 'next/link'

type ListGridProps = {
  columns?: number
  lists: {
    heading?: string
    links: {
      link: LinkProps
    }[]
  }[]
}

export default function ListGrid({ lists, columns = 4 }: ListGridProps) {
  if (!lists || !lists.length) {
    return null
  }

  // TODO simply use the column component???

  let gridClass = ''

  if (columns === 4) {
    gridClass = 's:grid-cols-1 s-up:grid-cols-2 m-up:grid-cols-4'
  } else if (columns === 3) {
    gridClass = 's:grid-cols-1 s-up:grid-cols-2 m-up:grid-cols-3'
  }

  const singleTemplateClass = `
    @[0px]/single:!grid-cols-1
    @[600px]/single:!grid-cols-2
  `

  return (
    <div className="component component--link-grid">
      <div className="container">
        <ul
          className={`grid ${gridClass} ${singleTemplateClass} w-full gap-y-l s:gap-x-l s-up:gap-x-xs ms-up:gap-x-m`}>
          {lists.map((column, index) => (
            <ListGridColumn column={column} key={index} />
          ))}
        </ul>
      </div>
    </div>
  )
}

export function ListGridColumn({ column }) {
  const { heading = '', links } = column

  if (!links || !links.length) {
    return null
  }

  const linksList = links.map((link, index) => {
    if (!link.link) {
      return null
    }

    return <ListGridItem key={index} link={link.link} />
  })

  return (
    <div className="relative">
      {heading ? <h5>{heading}</h5> : null}

      {linksList ? <ul>{linksList}</ul> : null}
    </div>
  )
}

export function ListGridItem({ link }) {
  if (!link) {
    return null
  }

  const { target = '', title, url } = link as LinkProps

  if (!url || !title) {
    return null
  }

  const transitionClass = `transition-colors duration-100 ease-in-out`

  return (
    <li
      className={`${transitionClass} p--small -mt-px mb-0 border-b border-gradient first:border-t hover:z-10 hover:text-link`}>
      <Link
        href={url}
        target={target}
        className={`relative flex items-center justify-between gap-m py-s`}>
        {title}
        <svg aria-hidden="true" className="aspect-square w-[24px]">
          <use href={`${process.env.NEXT_PUBLIC_SPRITE_PATH}#icon-chevron-right`}></use>
        </svg>
      </Link>
    </li>
  )
}
